import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';

import MfproductDashboard from '../MfproductDashboard';
import { getListAPI as getMfproductList } from 'components/mfproduct/MfproductAPI';
import { setMfproductList, setMfproductDashboardMfproductList } from 'store/slice/ManufSlice';

import { openDrawer } from './../../../store/slice/MenuSlice';

export default function MfproductPageImpl() {
    const dispatch = useDispatch();
    const { mfproductList} = useSelector((state)=>state.manufslice);
    
    const getMfproductListSuccess = (list) =>{dispatch(setMfproductList(list));}
    useEffect(() => {
        //dispatch(openDrawer(false));
        getMfproductList(()=>{}, getMfproductListSuccess);
    },[]);
    useEffect(()=>{
        setMfproductDashboardMfproductList( mfproductList);
    },[ mfproductList])

    return (
        < MfproductDashboard />
    )

}